/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/*
Author: Lukman Yudokusumo
*/

import React, { useState, useEffect, useMemo } from 'react';
import Toast from 'react-native-toast-message';
import {
  View,
  StyleSheet,
  Text,
  Dimensions,
  TouchableOpacity,
} from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { showPopup } from '@/store/modal';
import {
  changeLanguage,
  SUPPORTED_LANGUAGES,
  VISIBLE_LANGUAGES,
} from '@/store/language';

import { setCountryCookieAndRedirect } from '@/store/auth/actions';
import Image from '@components/global/Image';
import { Ionicons } from '@expo/vector-icons';
import ModalTopRounded from '@components/modal/ModalTopRounded';
import RadioIcon from '@components/shared/RadioIcon';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import { isVn } from '@global/helpers';
import Colors from '@global/colors';
import { isWeb, isMobileWeb, isNative } from '@global/screens';

import packageJson from '../../../package.json';

const isLoginScreen = global.pageFrom === 'LoginScreen';

const windowWidth = Dimensions.get('window').width;
const dynamicWidth = windowWidth * 0.6;

const logoOnNavbar = {
  width: 32,
  height: 32,
};

const renderLogo = () => (
  <Image
    key="logoApps"
    width={logoOnNavbar.width}
    height={logoOnNavbar.height}
    style={styles.logoApps}
    resizeMode="contain"
    source={require('@assets/img/logo/nina_2025.svg')}
    svg
  />
);

const renderVersionText = (isLoggedIn, version) => (
  <Text
    style={{
      fontSize: isLoggedIn ? 10 : 12,
      textAlign: !isLoggedIn ? 'center' : 'left',
      fo: 'figtree-semiBold',
      fontFamily: 'figtree-semiBold',
      color: isWeb ? Colors.white : Colors.black1,
      marginLeft: isLoggedIn ? 10 : 0,
      marginTop: isWeb ? 150 : 0,
    }}>
    {`V${version}`}
  </Text>
);

const VersionApp = ({ showLogo = true }) => {
  const dispatch = useDispatch();
  const [isVietnam, setIsVietnam] = useState(false);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isShow = useSelector((state) => state.modal);
  const isShowChangeCountry = isShow.changeCountry;
  const isShowChangeLanguage = isShow.changeLanguage;
  const language = useSelector((state) => state.language.selected);
  const userData = useSelector((state) => state.auth.user);
  const countryList = userData?.is_active_for?.length
    ? userData?.is_active_for?.reduce((acc, val) => {
        const countryMap = {
          b2b_vn: { name: 'Vietnam', value: 'VN' },
          b2b: { name: 'Indonesia', value: 'ID' },
        };
        if (countryMap[val]) {
          acc.push(countryMap[val]);
        }
        return acc;
      }, [])
    : [
        { name: 'Indonesia', value: 'ID' },
        { name: 'Vietnam', value: 'VN' },
      ];

  const version = packageJson.version;
  const styleContainer = isLoggedIn
    ? styles.wrapperLogin
    : styles.wrapperUnLogin;

  const checkCountry = () => {
    const result = isVn();
    setIsVietnam(result);
  };

  const handleSelectCountry = async (payload) => {
    const selectedCountry = payload.country.value;
    const coun = selectedCountry == 'VN' ? 'b2b_vn' : 'b2b';
    if (!(userData?.is_active_for || []).includes(coun)) {
      Toast.show({
        text1: 'You cannot switch country',
        type: 'error',
      });
      dispatch(showPopup({ name: 'changeCountry', value: false }));
      return;
    }
    await setCountryCookieAndRedirect(selectedCountry, dispatch);
    await checkCountry();

    dispatch(showPopup({ name: 'changeCountry', value: false }));
  };

  const handleSelectLanguage = (payload) => {
    const selectedLanguage = payload.language;
    if (!selectedLanguage?.enabled) {
      return;
    }
    dispatch(changeLanguage(selectedLanguage.code));
    dispatch(showPopup({ name: 'changeLanguage', value: false }));
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      checkCountry();

      if (!isVietnam) {
        const userVietnam =
          Array.isArray(userData?.is_active_for) &&
          userData?.is_active_for?.length === 1 &&
          userData?.is_active_for?.every((val) => val === 'b2b_vn');
        if (userVietnam) {
          setIsVietnam(true);
        }
      }
    }

    return () => {
      isMounted = false;
    };
  }, []);

  const CountryInfo = useMemo(() => {
    return (
      <>
        <Image
          style={{ width: 16, height: 16, marginRight: 10 }}
          width={16}
          height={16}
          svg={true}
          source={
            isVietnam
              ? require('@/assets/img/icons/VN.svg')
              : require('@/assets/img/icons/ID.svg')
          }
        />
        <Text style={styles.profileName} numberOfLines={1}>
          {isVietnam ? 'VN' : 'ID'}
        </Text>
      </>
    );
  }, [isVietnam]);

  const renderCountrySection = useMemo(() => {
    return !isWeb ? (
      <TouchableOpacity
        onPress={() =>
          dispatch(showPopup({ name: 'changeCountry', value: true }))
        }>
        <View
          style={[
            styles.countryWrapper,
            styles.flexWrapper,
            { justifyContent: 'space-between' },
          ]}>
          <Text
            style={{
              fontSize: 12,
              fontFamily: 'figtree-regular',
            }}>
            Country
          </Text>
          <View style={styles.flexWrapper}>
            {CountryInfo}
            <Image
              source={require('@assets/img/icons/arrow-down-grey.svg')}
              style={{ width: 10, height: 5, marginLeft: 5 }}
              width={10}
              height={5}
              svg={true}
            />
          </View>
        </View>
      </TouchableOpacity>
    ) : (
      false
    );
  }, [CountryInfo]);

  const LanguageInfo = useMemo(() => {
    const currentLanguage =
      SUPPORTED_LANGUAGES.find((lang) => lang.code === language) ||
      SUPPORTED_LANGUAGES[0];
    return (
      <>
        <Image
          style={{ width: 16, height: 16, marginRight: 10 }}
          width={16}
          height={16}
          svg={true}
          source={require('@/assets/img/icons/globe-grey.svg')}
        />
        <Text style={styles.profileName} numberOfLines={1}>
          {currentLanguage.label}
        </Text>
      </>
    );
  }, [language]);

  const renderLanguageSection = useMemo(() => {
    return !isWeb ? (
      <TouchableOpacity
        onPress={() =>
          dispatch(showPopup({ name: 'changeLanguage', value: true }))
        }>
        <View
          style={[
            styles.countryWrapper,
            styles.languageWrapper,
            styles.flexWrapper,
            { justifyContent: 'space-between' },
          ]}>
          <Text
            style={{
              fontSize: 12,
              fontFamily: 'figtree-regular',
            }}>
            Language
          </Text>
          <View style={styles.flexWrapper}>
            {LanguageInfo}
            <Image
              source={require('@assets/img/icons/arrow-down-grey.svg')}
              style={{ width: 10, height: 5, marginLeft: 5 }}
              width={10}
              height={5}
              svg={true}
            />
          </View>
        </View>
      </TouchableOpacity>
    ) : (
      false
    );
  }, [LanguageInfo]);

  return (
    <View style={styleContainer}>
      {isWeb && isLoggedIn && showLogo && renderLogo()}
      {isLoggedIn && (
        <View style={{ flexDirection: 'column' }}>
          {renderCountrySection}
          {renderLanguageSection}
        </View>
      )}
      {!isNative && !isLoggedIn && renderVersionText(isLoggedIn, version)}
      <ModalTopRounded
        title="Select Country"
        visible={isShowChangeCountry}
        maxWidth={isWeb ? 400 : '100%'}
        onClose={() =>
          dispatch(showPopup({ name: 'changeCountry', value: false }))
        }
        children={
          <Formik
            initialValues={{ country: {} }}
            validationSchema={Yup.object({
              country: Yup.object().shape({
                value: Yup.string().required('Select a country'),
                name: Yup.string().required('Country name is required'),
              }),
            })}
            onSubmit={handleSelectCountry}>
            {({ values, setFieldValue, handleSubmit }) => (
              <View style={{ paddingTop: 5 }}>
                <View
                  style={{
                    paddingHorizontal: 20,
                    paddingBottom: 20,
                  }}>
                  {countryList.map((country, index) => {
                    const isSelected = values?.country?.value === country.value;
                    const flagSource =
                      country.value === 'VN'
                        ? require('@/assets/img/icons/VN.svg')
                        : require('@/assets/img/icons/ID.svg');

                    return (
                      <View key={country.value + index}>
                        <TouchableOpacity
                          activeOpacity={0.7}
                          onPress={() => setFieldValue('country', country)}
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            paddingVertical: 12,
                          }}>
                          <View
                            style={{
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}>
                            <Image
                              style={{
                                width: 22,
                                height: 22,
                                marginRight: 12,
                              }}
                              width={22}
                              height={22}
                              svg={true}
                              source={flagSource}
                            />
                            <SociollaText
                              type={isSelected ? 'bold' : 'primary'}
                              style={{
                                fontSize: 14,
                                color: isSelected
                                  ? Colors.blue0
                                  : Colors.black1,
                              }}>
                              {country.name}
                            </SociollaText>
                          </View>
                          {isSelected && (
                            <Ionicons
                              name="checkmark-sharp"
                              size={20}
                              color={Colors.blue0}
                            />
                          )}
                        </TouchableOpacity>
                        {index < countryList.length - 1 && (
                          <View
                            style={{
                              height: 1,
                              backgroundColor: Colors.grey0,
                            }}
                          />
                        )}
                      </View>
                    );
                  })}
                </View>
                <View
                  style={{
                    paddingVertical: 5,
                    paddingHorizontal: 20,
                  }}>
                  <Button
                    rounded={true}
                    buttonStyle={{ width: '100%' }}
                    disabledStyle={{ width: '100%' }}
                    disabled={!values?.country?.value}
                    title={
                      <SociollaText
                        type="primary"
                        style={{ fontSize: 14, color: Colors.white }}>
                        {'Select'}
                      </SociollaText>
                    }
                    onPress={handleSubmit}
                  />
                </View>
              </View>
            )}
          </Formik>
        }
      />
      <ModalTopRounded
        title="Select Language"
        visible={isShowChangeLanguage}
        maxWidth={isWeb ? 400 : '100%'}
        onClose={() =>
          dispatch(showPopup({ name: 'changeLanguage', value: false }))
        }
        children={
          <Formik
            enableReinitialize
            initialValues={{
              language:
                SUPPORTED_LANGUAGES.find((lang) => lang.code === language) ||
                {},
            }}
            validationSchema={Yup.object({
              language: Yup.object().shape({
                code: Yup.string().required('Select a language'),
              }),
            })}
            onSubmit={handleSelectLanguage}>
            {({ values, setFieldValue, handleSubmit }) => (
              <View style={{ paddingTop: 5 }}>
                <View
                  style={{
                    paddingHorizontal: 20,
                    paddingBottom: 20,
                  }}>
                  {VISIBLE_LANGUAGES.map((lang, index) => {
                    const isSelected = values?.language?.code === lang.code;

                    return (
                      <View key={lang.code}>
                        <TouchableOpacity
                          activeOpacity={lang.enabled ? 0.7 : 1}
                          disabled={!lang.enabled}
                          onPress={() => setFieldValue('language', lang)}
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            paddingVertical: 12,
                            opacity: lang.enabled ? 1 : 0.4,
                          }}>
                          <View
                            style={{
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}>
                            <RadioIcon selected={isSelected} />
                            <SociollaText
                              type={isSelected ? 'bold' : 'primary'}
                              style={{
                                fontSize: 14,
                                color: isSelected
                                  ? Colors.blue0
                                  : Colors.black1,
                              }}>
                              {lang.label}
                            </SociollaText>
                          </View>
                        </TouchableOpacity>
                        {index < VISIBLE_LANGUAGES.length - 1 && (
                          <View
                            style={{
                              height: 1,
                              backgroundColor: Colors.grey0,
                            }}
                          />
                        )}
                      </View>
                    );
                  })}
                </View>
                <View
                  style={{
                    paddingVertical: 5,
                    paddingHorizontal: 20,
                  }}>
                  <Button
                    rounded={true}
                    buttonStyle={{ width: '100%' }}
                    disabledStyle={{ width: '100%' }}
                    disabled={!values?.language?.code}
                    title={
                      <SociollaText
                        type="primary"
                        style={{ fontSize: 14, color: Colors.white }}>
                        {'Select'}
                      </SociollaText>
                    }
                    onPress={handleSubmit}
                  />
                </View>
              </View>
            )}
          </Formik>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  wrapperLogin: {
    width: isLoginScreen ? 400 : windowWidth,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 7,
    marginBottom: 10,
    marginLeft: 10,
  },
  logoApps: {
    width: logoOnNavbar.width,
    height: logoOnNavbar.height,
  },
  profileName: {
    maxWidth: 90,
    fontSize: 12,
    fontFamily: 'figtree-regular',
    color: Colors.black1,
    flexShrink: 1,
  },
  wrapperUnLogin: {
    width: isWeb ? 400 : 350,
    marginHorizontal: 'auto',
    alignItems: 'center',
    marginTop: isMobileWeb ? -50 : 0,
    marginBottom: isMobileWeb ? 40 : 0,
  },
  countryWrapper: {
    width: dynamicWidth,
    padding: 10,
    fontSize: 12,
    fontFamily: 'figtree-regular',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: Colors.grey0,
  },
  languageWrapper: {
    borderTopWidth: 0,
  },
  flexWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
    minWidth: 0,
    fontSize: 12,
    fontFamily: 'figtree-regular',
  },
});

export default VersionApp;
